<template>
  <!--  <el-dialog title="新增 / 編輯车型" :visible.sync="addModelFormVisible" :modal-append-to-body='false'>-->
  <EditFormDialog
    :formData="editModelForm"
    :formVisible="formVisible"
    :formType="'update'"
    :loading="editModelFormVisible"
    @submitForm="editModelSubmit"
    @closeDialog="closeDialog"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <el-form :rules="editFormRules" :model="editModelForm" ref="editModelForm" size="mini" class="edit_form">
      <el-form-item label="品牌" :label-width="formLabelWidth" prop="brand">
<!--        &lt;!&ndash;            <el-input placeholder="品牌" v-model="editModelForm.brand" clearable></el-input>&ndash;&gt;-->
        <el-select placeholder="品牌" v-model="editModelForm.brandId">
          <el-option v-for="item in listForSelectQuery" :key="item.id"
                     v-bind:label="item.brand" v-bind:value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="型号" :label-width="formLabelWidth" prop="model">
        <el-input placeholder="型号" v-model="editModelForm.model" autocomplete="off"></el-input>

      </el-form-item>
      <el-form-item label="类型" :label-width="formLabelWidth" prop="dynamicType">
        <el-select v-model="editModelForm.dynamicType" placeholder="车类型">
          <el-option label="纯电动" value="0"></el-option>
          <el-option label="混合动力" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="充电效率" :label-width="formLabelWidth" prop="chargingEfficiency">
        <el-input v-model="editModelForm.chargingEfficiency" autocomplete="off" placeholder="充电效率  单位:kW"></el-input>
      </el-form-item>
      <el-form-item label="续航" :label-width="formLabelWidth" prop="rangeOfVoyage">
        <el-input v-model="editModelForm.rangeOfVoyage" autocomplete="off" placeholder="续航  单位:km"></el-input>
      </el-form-item>
      <el-form-item label="最高时速" :label-width="formLabelWidth" prop="topSpeed">
        <el-input v-model="editModelForm.topSpeed" autocomplete="off" placeholder="最高时速  单位:km/h"></el-input>
      </el-form-item>
      <el-form-item label="车型结构" :label-width="formLabelWidth" prop="structure">
        <el-select v-model="editModelForm.structure" placeholder="车型结构">
          <el-option label="轿车" value="0"></el-option>
          <el-option label="跑车" value="1"></el-option>
          <el-option label="面包车" value="2"></el-option>
          <el-option label="货车" value="3"></el-option>
          <el-option label="皮卡" value="4"></el-option>
          <el-option label="其它" value="5"></el-option>
        </el-select>
      </el-form-item>
       <el-form-item label="id" :label-width="formLabelWidth" prop="id" hidden >
        <el-input v-model.number="editModelForm.id" autocomplete="off" placeholder="id"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="editModelFormVisible = false">取 消</el-button>
      <el-button size="small" type="primary" @click.native="editModelSubmit" :loading="editModelSubmitLoading">确 定
      </el-button>
    </div>
  </EditFormDialog>
</template>

<script>
    import Pagination from "../../../../../components/Pagination";
    import carApi from "../../../api/carApi";
    import EditFormDialog from '@/components/EditFormDialog'
    import commonApi from "../../../api/commonApi";
    import {isDecimalThanZero, isInteger, validateInput, validatePhone} from '../../../../../common/validator'
    export default {
        props: {

            selectRowData: {
                type: Object,
                required: true
            },
            formVisible: {
              type: Boolean,
              required: true
            }
        },
        name: "edit",
        data() {
            return {
                editFormRules: {
                    brandId: [{required: true, message: '请选择品牌', trigger: 'blur'}],
                    model: [
                        {required: true, message: '请输入车型', trigger: 'blur'},{
                            validator: function (rule, value, callback) {
                                validateInput(rule, value, callback, 0, 10, true, true, true, false, false, true, false)
                            }, required: true,trigger: 'blur'
                        }],
                    dynamicType: [{required: true, message: '请选择类型', trigger: 'blur'}],

                    carTypeId: [{required: true, message: '请选择车型', trigger: 'blur'}],
                    chargingEfficiency: [
                        {required: true, message: '请输入充电效率', trigger: 'blur'},{
                            validator: function (rule, value, callback) {
                                validateInput(rule, value, callback, 0, 5, true, true, true, false, false, false, true)
                            },required: true, trigger: 'blur'
                        }],
                    rangeOfVoyage: [
                        {required: true, message: '请输入里程', trigger: 'blur'},{
                            validator: function (rule, value, callback) {
                                validateInput(rule, value, callback, 0, 5, true, true, true, false, false, false, true)
                            }, required: true,trigger: 'blur'
                        }],
                    topSpeed: [
                        {required: true, message: '请输入最大速度', trigger: 'blur'},{validator: function (rule, value, callback) {
                                validateInput(rule, value, callback,0,5,true,true,true,false,false,false,true)
                            },required: true,trigger: 'blur'}],
                    structure: [{required: true, message: '请选择结构', trigger: 'blur'}],
                },
                views: {},
                enumData: [{
                    carTypeData: ''
                }],
                inputVisible: false,
                inputValue: '',
                // restaurants: [],
                tableData: [{}],
                modelTableData: [{}],
                brandTableData: [{}],
                carSearchForm: {},
                modelSearchForm: {},
                brandSearchForm: {},
                listForSelectQuery: {},
                operatorForSelect: '',
                listForSelect: {},
                getCarsLoading: false,
                getBrandLoading: false,
                getModelsLoading: false,
                addForm: {},
                editForm: {},
                carsLoading: false,
                addModelForm: {},
                editModelForm: {},
                addBrandForm: {},
                editBrandForm: {},
                editTypeForm: {},
                addSubmitLoading: false,
                editSubmitLoading: false,
                carModelLoading: false,
                addModelSubmitLoading: false,
                editModelSubmitLoading: false,
                addBrandSubmitLoading: false,
                editBrandSubmitLoading: false,
                carBrandLoading: false,
                innerForm: {},
                searchTabsAddForm: {},
                addFormVisible: false,
                editFormVisible: false, // 外部对话框
                addModelFormVisible: false,
                editModelFormVisible: false,
                addBrandFormVisible: false,
                editBrandFormVisible: false,
                viewVisible: false, // 视图
                multipleSelection: [],
                activeName: 'modelList',
                innerFormName: 'coordinate',
                viewName: 'detailForm',
                showFilters: true,
                input: '',
                val_time: '', // 创建时间
                formLabelWidth: '150px',
                // 分页参数
                pageparm: {
                    t: {},
                    currentPage: 1,
                    pageSize: 10,
                    total: 0
                },
                activeNames: ['basicInformation', 'addressInformation'],
                activeName: 'modelList',
                rules: {
                  chargingEfficiency: [{validator: isInteger, trigger: 'blur'}],
                  rangeOfVoyage: [{validator: isInteger, trigger: 'blur'}],
                  topSpeed: [{validator: isInteger, trigger: 'blur'}],
                }
            }
        },
        watch: {
            selectRowData: {
                handler: function (selectRowData) {
                    this.editModelForm = Object.assign({}, selectRowData)
                    // this.formData.state = selectRowData.state && selectRowData.state.code
                },
                immediate: false
            },
            formVisible: {
              handler: function () {
                this.initCarBrand();
              }
            }
        },
        methods: {
            initCarBrand(){
              let param = Object.assign({}, this.pageparm);
              commonApi.listForSelectQuery(param).then((res) => {
                if (res.code === 0) {
                  this.listForSelectQuery = res.data.records
                }
              })
            },
            closeDialog(formType) {
                this.$refs.editModelForm.clearValidate()
                this.$emit("closeDialog", formType)
            },
            editModelSubmit(editModelForm) {

                console.log(this.editModelForm)
                this.$refs.editModelForm.validate((valid) => {
                    if (!valid) {
                        return;
                    } else {
                      this.editModelSubmitLoading = true
                      let param = JSON.stringify(this.editModelForm)
                      carApi.saveOrUpdateModel(param).then((res) => {
                        this.editModelSubmitLoading = false
                        if (res.code === 0) {
                          this.$message({
                            message: res.message,
                            type: 'success'
                          })
                          this.editModelFormVisible = false
                          this.$emit('afterEdit')
                          // this.submitModelSearchForm()
                        } else {
                          this.$message.error(res.message)
                        }
                      })
                    }
                })
            },
            // 加载下拉框
            loadSelectItem() {
                let param = Object.assign({}, this.pageparm)
                // brand下拉框
                commonApi.listForSelectQuery(param).then((res) => {

                    if (res.code === 0) {
                        this.listForSelectQuery = res.data.records
                    }
                })
                // 运营商下拉框
                commonApi.operatorSelectionList().then((res) => {
                    if (res.code === 0) {
                        this.operatorForSelect = res.data
                    }

                })
                // model下拉框
                // commonApi.listForSelect(param).then((res) => {

                //     if (res.code === 0) {
                //         this.listForSelect = res.data.records
                //     }
                //     console.log(res)
                // })
            },

        },
        components: {
            Pagination,
            EditFormDialog
        },
        created: function () {
            this.loadSelectItem()
        },
        mounted: function () {
            console.log(this.editModelForm)

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/car/model/edit.vue